<template>
  <div v-if="!shouldHideOverviewForCategory">
    <div class="d-flex justify-content-center align-items-center mb-10">
      <div class="btn-group">
        <button
          type="button"
          class="btn btn-sm"
          :class="
            selectedTab === 'overall'
              ? 'btn-primary btn-active'
              : 'btn-secondary'
          "
          @click="onTabClicked('overall')"
        >
          {{ $t('categoryDetails.toggleButton.overview') }}
        </button>
        <button
          type="button"
          class="btn btn-sm"
          :class="
            selectedTab === 'questions'
              ? 'btn-primary btn-active'
              : 'btn-secondary'
          "
          @click="onTabClicked('questions')"
        >
          {{ $t('categoryDetails.toggleButton.questions') }}
        </button>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'CategoryDetailsTagSelector',
  props: {
    selectedTab: {
      type: String,
      required: true
    },
    shouldHideOverviewForCategory: {
      type: Boolean,
      default: false
    }
  },
  emits: ['tabSelected'],
  methods: {
    onTabClicked(tabName) {
      this.$emit('tabSelected', tabName)
    }
  }
}
</script>
